import { tgxApi } from "../../../app/tgxApi";
import {
    getFileDownloadHeaders,
    handleQueryError,
} from "../../../helpers/utils/RtkQueryUtils";
import {getFileName, serialize} from "../../../helpers/utils/Utils";
import {downloadFile} from "../../../helpers/utils/FileUtils";

export const externalApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        getAllExternalStates: build.query({
            query: () => {
                return {
                    url: `/external/get-all-states`,
                    method: 'GET',
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getAllExternalCountyByStateAbbr: build.query({
            query: (stateAbbreviation) => {
                return {
                    url: `/external/county-by-state/${stateAbbreviation}`,
                    method: 'GET'
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        searchExternalBillReleases: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/external/billReleases?${paramData}`,
                    method: 'POST',
                };
            },
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        exportExternalBillReleases: build.query({
            query: (query) => {
                return {
                    url: `/external/billRelease`,
                    method: 'POST',
                    params: query,
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("TGX_BillReleaseExport"))
                        return { success: true };
                    },
                };
            },
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

    }),
});


export const {
    useGetAllExternalStatesQuery,
    useSearchExternalBillReleasesQuery,
    useLazyGetAllExternalCountyByStateAbbrQuery,
    useLazyExportExternalBillReleasesQuery
} = externalApi;